import PropTypes from 'prop-types';
import React from 'react';

const ServerErrorAlert = ({
  headline = 'Something went wrong on our end',
  description = 'We’re sorry. Something went wrong on our end. Try again later.',
}) => (
  <va-alert status="error" data-testid="hca-server-error-alert">
    <h2 slot="headline">{headline}</h2>
    <p>{description}</p>
  </va-alert>
);

ServerErrorAlert.propTypes = {
  description: PropTypes.string,
  headline: PropTypes.string,
};

export default React.memo(ServerErrorAlert);
